import { AppDispatch } from "../store";
import { CallResult, ErrorResponse } from "../../api/Requests";
import { RequestKind } from "../../types/requestTypes";
import { requestError, requestSuccess, startRequest } from "../reducers/requestStateSlice";
import { ErrorCode } from "../../api/errorCode";

export async function handleRequest<T>(
    dispatch: AppDispatch,
    kind: RequestKind,
    requestFn: () => Promise<CallResult<T>>,
    successMessage?: string,
    options?: { suppressErrorCodes?: ErrorCode[] }
): Promise<CallResult<T>> {
  dispatch(startRequest({ kind }));
  const result = await requestFn();

  if (result.success()) {
    if (kind === "direct" && successMessage) {
      dispatch(requestSuccess({ message: successMessage }));
    } else {
      dispatch(requestSuccess({}));
    }
  } else {
    const suppressed = options?.suppressErrorCodes?.includes(
        result.errorResponse?.errorCode ?? ErrorCode.GeneralError
    );

    if (!suppressed) {
      const defaultResponse: ErrorResponse = {
        message: "Unknown Error",
        errorCode: ErrorCode.GeneralError,
        statusCode: 0,
      };
      dispatch(requestError(result.errorResponse ?? defaultResponse));
    }
  }

  return result;
}
